import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../../components/Modal/modal';
import style from '../../css/patients.module.css';
import { Button, Grid } from '@material-ui/core';
import { ApiServerUrl } from '../../../config.json';
import join from 'url-join';
import { Link, useHistory } from 'react-router-dom';
import { updateLastOpenCaseId } from '../../../store/NewCase/NewCase.action';

const formatNewCaseLink = (v, selectCaseOptionType, currentPatientId) => {
    return currentPatientId
        ? `/patients/${currentPatientId}/newCase/${v['case_type']}`
        : `/patients/newPatient/${v['case_type']}`;
};

const SmileDesignNewCaseModal = ({ isOpen, setIsOpen, currentCaseId = undefined, patientId = undefined }) => {
    const { productMatrixArray, productList } = useSelector((state) => state.smileDesign);
    const history = useHistory();
    const dispatch = useDispatch();
    return (
        <Modal
            className="modal"
            title="New Smile Design Case"
            open={isOpen}
            handleClose={() => setIsOpen(false)}
            modalSize="md"
            submitButton={false}
        >
            <Grid container>
                {productMatrixArray?.map((v, _) => {
                    if (/SMILE_DESIGN/.test(v.case_type)) {
                        return (
                            <Grid
                                item
                                xs={6}
                                   sm={4}
                                style={{ textAlign: 'center', padding: '4px 4px' }}
                                key={`SmileDesign-${v.case_type}`}
                            >
                                <Link
                                    onClick={() => {
                                        if (currentCaseId != null && currentCaseId != undefined) {
                                            dispatch(updateLastOpenCaseId(currentCaseId));
                                        }
                                    }}
                                    to={formatNewCaseLink(v, v.case_type, patientId)}
                                    className={style.NewCaseModalLink}
                                    style={{ color: 'unset', textDecoration: 'none' }}
                                >
                                       <div className={style.NewSmileDesignCaseModalBackground}></div>
                                    <Button
                                           className={style.NewSmileDesignCaseModalButton}
                                        style={{ backgroundColor: v['color_code'] }}
                                    >
                                        <img
                                            className={style.NewSmileDesignCaseModalImage}
                                            src={join(ApiServerUrl, `/file/config/${v.product_image}`)}
                                        />
                                        <div className={style.NewSmileDesignCaseModalName}>
                                               <div>Align &amp; Restore Case</div>
                                               <div>(Integrative Smile Design™)</div>
                                        </div>
                                        <div className={style.NewCaseModalDescription}>
                                            <ul>
                                                {v['product_desc']?.split(/\r?\n/).map((v) => (
                                                    <li key={v}>{v}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </Button>
                                </Link>
                            </Grid>
                        );
                    }
                })}
            </Grid>
        </Modal>
    );
};

export default memo(SmileDesignNewCaseModal);
